var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"neterror",attrs:{"ontouchmove":"return false"}},[_c('img',{staticClass:"img",attrs:{"src":_vm.pic}}),_c('p',{staticClass:"tips"},[_vm._v(_vm._s(_vm.tips))]),(_vm.type==0)?_c('p',{staticClass:"reload",on:{"click":_vm.retry}},[_vm._v("重新加载")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }